export default __webpack_public_path__ + "static/Mestre Anderson Miguel_MiniBio-07ed05686bcda7654906ba050ee6c8b5.webp";